// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__1-5H3","title":"AfterImages45_title__2GCu_","images":"AfterImages45_images__2g4Go"};